import component from './AuthRoute'

export default component
